import { texteHtmlMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [texteHtmlMock('mentions-legales')];

export const mentionsLegalesMock: SlugPage = {
  ...pageBase({
    title: 'Mentions Legales',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
